import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile } from "../../utils/tools";
import { formatDateToLocal } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import iconFile from "../../assets/images/apartment/Frame.svg";
import { useLocation } from "react-router-dom";

export default function Disbursement() {
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const getLockingId = () => searchParams.get("lockingId") || "";
  // const getPeriod = () => searchParams.get("period") || 1;

  const [lockingId, setLockingId] = useState(getLockingId);
  // const [period, setPeriod] = useState(getPeriod);

  // Đồng bộ state khi URL param thay đổi
  useEffect(() => {
    setLockingId(getLockingId());
    // setPeriod(getPeriod());
    // eslint-disable-next-line
  }, [location.search]);

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      {/* <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý đợt thanh toán
          </Text>
        </Flex>
      </Flex> */}
      <Box>
        <TableLocking
          lockingId={lockingId}
          // period={period}
        />
      </Box>
    </Box>
  );
}
